/* Nirvam — page interactions ported from the source design's Component
   class to plain vanilla JS (no React / dc-runtime dependency). */
(function () {
  'use strict';

  // ---- Countdown timer ----
  function initCountdown() {
    var root = document.querySelector('[data-countdown]');
    if (!root) return;
    var end = new Date(root.getAttribute('data-offer-end')).getTime();
    var activeEl = root.querySelector('[data-countdown-active]');
    var expiredEl = root.querySelector('[data-countdown-expired]');
    var dEl = root.querySelector('[data-cd-d]');
    var hEl = root.querySelector('[data-cd-h]');
    var mEl = root.querySelector('[data-cd-m]');
    var sEl = root.querySelector('[data-cd-s]');

    function pad(n) { return String(n).padStart(2, '0'); }

    function tick() {
      var diff = Math.max(0, Math.floor((end - Date.now()) / 1000));
      if (diff <= 0 && !isNaN(end)) {
        if (activeEl) activeEl.style.display = 'none';
        if (expiredEl) expiredEl.style.display = 'block';
        clearInterval(timer);
        return;
      }
      var d = Math.floor(diff / 86400); diff -= d * 86400;
      var h = Math.floor(diff / 3600); diff -= h * 3600;
      var m = Math.floor(diff / 60);
      var s = diff - m * 60;
      if (dEl) dEl.textContent = String(d);
      if (hEl) hEl.textContent = pad(h);
      if (mEl) mEl.textContent = pad(m);
      if (sEl) sEl.textContent = pad(s);
    }
    tick();
    var timer = setInterval(tick, 1000);
  }

  // ---- Scroll reveal ----
  function initReveal() {
    document.body.classList.add('nv-js');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('nv-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    document.querySelectorAll('[data-rv]').forEach(function (el) { io.observe(el); });
  }

  // ---- FAQ accordion ----
  function initFaq() {
    document.querySelectorAll('[data-faq-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('[data-faq-item]');
        var isOpen = item.classList.contains('is-open');
        var siblingsRoot = item.parentElement;
        siblingsRoot.querySelectorAll('[data-faq-item].is-open').forEach(function (openItem) {
          openItem.classList.remove('is-open');
          openItem.querySelector('[data-faq-toggle]').setAttribute('aria-expanded', 'false');
        });
        if (!isOpen) {
          item.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  // ---- Horizontal sliders (product slider + ME Period slider) ----
  function initSliders() {
    document.querySelectorAll('[data-slider]').forEach(function (slider) {
      var name = slider.getAttribute('data-slider');
      var cap = parseInt(slider.getAttribute('data-slider-cap'), 10) || 900;
      var prev = document.querySelector('[data-slider-prev="' + name + '"]');
      var next = document.querySelector('[data-slider-next="' + name + '"]');
      function slide(dir) {
        var amount = dir * Math.min(slider.clientWidth * 0.9, cap);
        slider.scrollBy({ left: amount, behavior: 'smooth' });
      }
      if (prev) prev.addEventListener('click', function () { slide(-1); });
      if (next) next.addEventListener('click', function () { slide(1); });
    });
  }

  // ---- Sherni Circle popup: auto-trigger once per session, after the shop
  // product cards have been scrolled well past (not while still in view) ----
  function initPopup() {
    var popup = document.querySelector('[data-sherni-popup]');
    if (!popup) return; // section hidden by merchant — nothing to wire
    var trigger = document.getElementById('shop');
    if (!trigger) return;
    var triggered = false;

    function onScroll() {
      if (triggered) return;
      var drawer = document.querySelector('[data-cart-drawer]');
      if (drawer && drawer.classList.contains('is-active')) return; // don't fight the cart drawer for attention
      var rect = trigger.getBoundingClientRect();
      if (rect.bottom < window.innerHeight * 0.15) {
        triggered = true;
        var seen = false;
        try { seen = sessionStorage.getItem('nv_sherni_seen') === '1'; } catch (e) {}
        if (!seen) {
          try { sessionStorage.setItem('nv_sherni_seen', '1'); } catch (e) {}
          popup.classList.add('is-active');
          var emailInput = popup.querySelector('input[type="email"]');
          if (emailInput) { try { emailInput.focus(); } catch (e) {} }
        }
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });

    // If the page reloaded after a form POST (e.g. the popup's own newsletter
    // submit), and the popup section is now showing its "success" state,
    // re-open it so the confirmation is visible instead of hidden behind a
    // fresh page load.
    if (popup.querySelector('[data-popup-success]')) {
      popup.classList.add('is-active');
    }
  }

  // ---- Hero slider: manual navigation only — dots, next arrow, swipe ----
  function initHeroSlider() {
    var slider = document.querySelector('[data-hero-slider]');
    if (!slider) return;
    var slides = Array.prototype.slice.call(slider.querySelectorAll('[data-hero-slide]'));
    var dots = Array.prototype.slice.call(slider.querySelectorAll('[data-hero-dot]'));
    var nextBtn = slider.querySelector('[data-hero-next]');
    var prevBtn = slider.querySelector('[data-hero-prev]');
    if (slides.length < 2) return;
    var current = 0;

    function updateArrows() {
      if (prevBtn) prevBtn.style.display = current === 0 ? 'none' : '';
      if (nextBtn) nextBtn.style.display = current === slides.length - 1 ? 'none' : '';
    }

    function show(idx) {
      if (idx < 0 || idx > slides.length - 1) return;
      current = idx;
      slides.forEach(function (s, si) { s.classList.toggle('is-active', si === idx); });
      dots.forEach(function (d, di) { d.classList.toggle('is-active', di === idx); });
      updateArrows();
    }

    dots.forEach(function (d) {
      d.addEventListener('click', function () {
        show(parseInt(d.getAttribute('data-hero-dot'), 10));
      });
    });

    if (nextBtn) {
      nextBtn.addEventListener('click', function () { show(current + 1); });
    }
    if (prevBtn) {
      prevBtn.addEventListener('click', function () { show(current - 1); });
    }
    updateArrows();

    // Swipe (touch)
    var touchStartX = null;
    var touchStartY = null;
    slider.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
    }, { passive: true });
    slider.addEventListener('touchend', function (e) {
      if (touchStartX === null) return;
      var dx = e.changedTouches[0].clientX - touchStartX;
      var dy = e.changedTouches[0].clientY - touchStartY;
      touchStartX = null;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return; // ignore small/vertical swipes
      if (dx < 0) {
        show(current + 1);
      } else {
        show(current - 1);
      }
    }, { passive: true });
  }

  // ---- Sherni Circle ebook signup -> Klaviyo direct list subscribe ----
  // The `customer` form above tags the shopper in Shopify, but that alone
  // never adds them to the Klaviyo list that triggers the ebook delivery
  // flow. Fired via Klaviyo's public Client API, safe to call from the
  // browser. Earlier this used fetch(..., {keepalive:true}) without waiting
  // for it, racing the native Shopify form's page navigation — unreliable
  // across browsers (esp. Safari/iOS), so the call could get dropped
  // mid-flight. Instead we hold the native submission with preventDefault(),
  // fire the request, and only call form.submit() once it settles (or a
  // short timeout elapses, so a slow/dead network never blocks signup).
  function initEbookKlaviyoSubscribe() {
    var KLAVIYO_COMPANY_ID = 'WR5XS7';
    var KLAVIYO_LIST_ID = 'XeJhER';
    var forms = document.querySelectorAll('#nv-sherni-popup-form, #nv-sherni-inline-form');
    Array.prototype.forEach.call(forms, function (form) {
      form.addEventListener('submit', function (e) {
        var emailInput = form.querySelector('input[name="contact[email]"]');
        var email = emailInput && emailInput.value ? emailInput.value.trim() : '';
        if (!email) return;

        e.preventDefault();

        var proceeded = false;
        function proceed() {
          if (proceeded) return;
          proceeded = true;
          form.submit();
        }

        try {
          fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO_COMPANY_ID, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
            body: JSON.stringify({
              data: {
                type: 'subscription',
                attributes: {
                  profile: { data: { type: 'profile', attributes: { email: email } } },
                  custom_source: 'Nirvam Sherni Circle eBook'
                },
                relationships: { list: { data: { type: 'list', id: KLAVIYO_LIST_ID } } }
              }
            })
          }).then(proceed, proceed);
        } catch (err) { proceed(); }

        setTimeout(proceed, 1500);
      });
    });
  }

  // ---- Mobile nav toggle ----
  function initMobileNav() {
    var toggle = document.querySelector('[data-mobile-nav-toggle]');
    var nav = document.querySelector('[data-mobile-nav]');
    if (!toggle || !nav) return;
    var menuIcon = toggle.querySelector('[data-icon-menu]');
    var closeIcon = toggle.querySelector('[data-icon-close]');
    function setOpen(isOpen) {
      nav.classList.toggle('is-active', isOpen);
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      if (menuIcon) menuIcon.style.display = isOpen ? 'none' : 'inline-flex';
      if (closeIcon) closeIcon.style.display = isOpen ? 'inline-flex' : 'none';
    }
    toggle.addEventListener('click', function () {
      setOpen(!nav.classList.contains('is-active'));
    });
    nav.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () { setOpen(false); });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initCountdown();
    initReveal();
    initFaq();
    initSliders();
    initPopup();
    initEbookKlaviyoSubscribe();
    initHeroSlider();
    initMobileNav();
  });
})();
